import * as userReducers from './user.reducers';
import * as userPasswordReducers from './user-password.reducers';
import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

export interface UserState {
  user: userReducers.UserState;
  userPassword: userPasswordReducers.UserPasswordState;
}

export const reducers: ActionReducerMap<UserState> = {
  user: userReducers.reducer,
  userPassword: userPasswordReducers.reducer,
};

export const getUserState = createFeatureSelector<UserState>('user');
